import React from 'react'

export const HTMLContent = ({ content, className }: any) => (
  <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
)
